import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {actions as actionsExternalOffer} from "../../actions/externalOfferActions";
import {connect} from "react-redux";
import Table from "../common/table/Table";
import ListItemMenu from "./ListItemMenu";
import {columns} from "./Columns";
import ExternalOfferDialog from "./ExternalOfferDialog";

const ExternalOffersList = ({list, actions}) => {

  const [edit, setEdit] = useState({
    open: false,
    id: null,
    data: {
      url: '',
      description: ''
    }
  });

  const onHandlePageChange = async (nextPage) => {
    actions.loadNextExternalOffers(nextPage);
  }

  const onHandlePageSizeChange = nextPageSize => {
    actions.loadExternalOffers(1, nextPageSize, list.sortedBy, list)
  }
  const onHandleSortChange = sortBy => {
    actions.loadExternalOffers(1, list.paging.pageSize, sortBy, list);
  }

  const onDeleteHandler = async (id) => {
    const result = await actions.delete(id);
    if (result) {
      actions.loadExternalOffers(1, list.paging.pageSize, list.sortedBy, list)
    }
  }

  useEffect(() => {
    actions.loadExternalOffers(1, list.paging.pageSize, list.sortedBy, list)
  }, []);

  return (
    <>
      <Table
        columns={[{
          Header: '',
          id: 'icon',
          // eslint-disable-next-line react/display-name
          Cell: row => <ListItemMenu itemId={row.original.id} onDeleteHandler={onDeleteHandler} onEditHandler={() => {
            setEdit({
              open: true,
              id: row.original.id,
              data: {
                url: row.original.url,
                description: row.original.description
              }
            })
          }}/>,
          width: 40,
          sortable: false,
          Filter: () => null,
        }, ...columns]}
        data={list.records}
        sortedBy={list.sortedBy}
        paging={list.paging}
        onPageChange={onHandlePageChange}
        onPageSizeChange={onHandlePageSizeChange}
        onSortedChange={onHandleSortChange}
        loading={list.loading}
        minRows={0}
        keyField="id"
      />
      <ExternalOfferDialog
        edit
        open={edit.open}
        initialValues={edit.data}
        onCancel={() => setEdit({
          open: false,
          id: null,
          data: {
            url: '',
            description: ''
          }
        })} onSubmit={async (data) => {
        const result = await actions.update(edit.id, data);
        if (result) {
          setEdit({
            open: false,
            id: null,
            data: {
              url: '',
              description: ''
            }
          })
          actions.loadExternalOffers(1, list.paging.pageSize, list.sortedBy, list);
        }
      }}/>
    </>
  )
}

ExternalOffersList.propTypes = {
  list: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actionsExternalOffer, dispatch)
  };
}

function mapStateToProps(state) {
  const externalOfferState = state.externalOffer;
  return {
    fetching: externalOfferState.fetching,
    list: externalOfferState.pagedData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalOffersList);
